import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography
} from "@material-ui/core";
import { DataGrid } from '@mui/x-data-grid';


import FetchApi from "../Service/FetchApi";
import Configs from "../Service/Configuration";

class FHTLogsAppointmentToSmsWeb extends React.Component {
  constructor(props) {
    super(props);
    this.pageOptions = {
      pageSize: 10,
      search: true,
      searchText:
        props.location.state === undefined
          ? null
          : props.location.state.Keyword,
      pageSizeOptions: [10, 20, 30],
    };
    this.selectionOptions = {
      pageSize: 10,
      pageSizeOptions: [10, 20, 30],
      selection: true,
    };

    this.triggers = {};
    this.snackbarMessage = "";
    this.snackbarVariant = "success";
    this.state = {
      fhtLog: [],
      isLoaded: false,
      rowsPerPage: 10,
    };
  }

  columns = [
    { field: "id", headerName: "Site ID", width: 120 },
    { field: "siteName", headerName: "Site Name", width: 250 },
    { field: "logDateReceived", headerName: "Date Received", width: 200 },
    { field: "logTotalAppointmentsSearched", headerName: "Appointments Searched", width: 300 },
    { field: "logAppointmentsFlagged24Hours", headerName: "Appointments Flagged - 24 Hours", width: 300 },
    { field: "logAppointmentsFlagged7Days", headerName: "Appointments Flagged - 7 Days", width: 300 },
    { field: "logTotalAppointmentsFlagged", headerName: "Appointments Flagged - Total", width: 300 },
    { field: "logCurrentPendingMessages", headerName: "Pending Messages", width: 220 },
    { field: "logSmsMessages24Hours", headerName: "All Messages - 24 Hours", width: 250 },
    { field: "logSmsMessages7Days", headerName: "All Messages - 7 Days", width: 250 },
    { field: "logTotalSmsMessagesSent", headerName: "All Messages - Total", width: 250 },
    { field: "logSmsReminderMessages24Hours", headerName: "Reminders - 24 Hours", width: 220 },
    { field: "logSmsReminderMessages7Days", headerName: "Reminders - 7 Days", width: 220 },
    { field: "logTotalSmsReminderMessagesSent", headerName: "Reminders - Total", width: 220 },
    { field: "logSmsMessagesFailed24Hours", headerName: "Failed - 24 Hours", width: 220 },
    { field: "logSmsMessagesFailed7Days", headerName: "Failed - 7 Days", width: 220 },
    { field: "logTotalSmsMessagesFailed", headerName: "Failed - Total", width: 220 },
    { field: "logDoNotContact24Hours", headerName: "Do Not Contact - 24 Hours", width: 250 },
    { field: "logDoNotContact7Days", headerName: "Do Not Contact - 7 Days", width: 250 },
    { field: "logTotalDoNotContact", headerName: "Do Not Contact - Total", width: 250 },
    { field: "logPatientResponses24Hours", headerName: "Responses - 24 Hours", width: 220 },
    { field: "logPatientResponses7Days", headerName: "Responses - 7 Days", width: 220 },
    { field: "logTotalPatientResponses", headerName: "Responses - Total", width: 220 },
  ];

  componentDidMount = () => {
    const siteTypeId = Configs.SiteConfigurationMapping[window.location.hostname].siteTypeID;
    const apiLogs = FetchApi(`AppointmentToSmsLogs?siteTypeId=${siteTypeId}&projectId=${1}`);
    apiLogs.get().then(logs => {
      const rows = logs.map(row => ({ id: row.site.fhtSiteId, siteName: row.site.fhtSiteName, ...row.log }));
      this.setState({ rows: rows, isLoaded: true });
    });
  };

  downloadLogs = () => {
    const headers = this.columns.map(column => column.field);
    const csvContent = "data:text/csv;charset=utf-8," +
      headers.join(",") + "\n" +
      this.state.rows.map(row => headers.map(header => row[header]).join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const date = new Date();
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `linkme_stats_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.csv`);
    document.body.appendChild(link);

    link.click();
  };

  render() {
    if (this.state.isLoaded) {
      return (
        <Box paddingX={2} paddingY={3}>
          <Typography variant="h5" component="h1" gutterBottom>WEB Logs</Typography>
          <Box height={720} paddingY={2}>
            <DataGrid
              columns={this.columns}
              rows={this.state.rows}
            ></DataGrid>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={this.downloadLogs}
          >
            Download as CSV
          </Button>
        </Box>
      );
    }
    else {
      return (
        <div>
          <CircularProgress></CircularProgress>
          Loading
        </div>
      );
    }
  }
}
export default (FHTLogsAppointmentToSmsWeb);
